// extracted by mini-css-extract-plugin
module.exports = {"TabComponent":"TabComponent_TabComponent__xvor0"};